export const getPriorityColor = (priority) => {
  switch (priority) {
    case 'urgent': return '#dc3545';
    case 'high': return '#fd7e14';
    case 'normal': return '#0d6efd';
    case 'low': return '#6c757d';
    default: return '#0d6efd';
  }
};

export const getPriorityIcon = (priority) => {
  switch (priority) {
    case 'urgent': return '🚨';
    case 'high': return '⚠️';
    case 'normal': return '📢';
    case 'low': return '📌';
    default: return '📢';
  }
};
